import {
  SignIn as ProviderSignIn,
  useAuth as useProviderAuth,
  useClerk as useProviderActions,
  useUser as useProviderUser,
} from '@clerk/clerk-react'

export const AuthSignIn = ProviderSignIn
export const useAuthState = useProviderAuth
export const useAuthActions = useProviderActions
export const useCurrentUser = useProviderUser

export { useOrganization, useOrganizationList } from '@clerk/clerk-react'
